import {
  DateTimeRangeDTO,
} from 'dtos';
import {
  formatISODateTime,
} from 'utils/date';
import {
  DateRange,
} from 'types/dateRange';

export type SerializedDateRange = Required<Pick<DateTimeRangeDTO, 'start' | 'end'>>;

export function serializeDateRange(dateRange?: DateRange): SerializedDateRange | undefined {
  if (!dateRange) {
    return undefined;
  }

  return {
    start: formatISODateTime(dateRange.min),
    end: formatISODateTime(dateRange.max),
  };
}
